// eslint-disable-next-line simple-import-sort/imports
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import BackArrowIcon from "@/shared-components/icons/components/public/BackArrowIcon";
import { useEffect, useState } from "react";
import PublicFormInput from "@/shared-components/inputs/components/PublicFormInput";
import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import AddArtworksPopup from "../add-artworks-popup";
import ArtworkRow from "./components/ArtworkRow";
import fetchWrapper from "@/services/fetchWrapper.service";
import config from "@/config";
import { DndContext, DragOverlay, MouseSensor, TouchSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { restrictToParentElement, restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { AutoSizer, List } from "react-virtualized";

export default function AddCarousel() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [error, setError] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [title, setTitle] = useState(id);
  const [artworks, setArtworks] = useState([]);
  const [activeArtworkId, setActiveArtworkId] = useState(null);
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 0 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 5 } }),
  );

  useEffect(() => {
    setError(null);
  }, []);

  const onClickBack = () => {
    navigate("/admin/customize-home");
  };

  const onAddArtworks = (data) => {
    setArtworks(data);
    setPopupOpen(false);
  };

  const getIdFromTitle = () => {
    const string = title;
    const mArr = string.split(' ');
    for(let i = 0; i < mArr.length; i ++)
      mArr[i] = mArr[i].toLowerCase();
    return mArr.join('-');
  };

  const onSaveChanges = async () => {
    if(!title || !title.length) {
      alert("Title can't be empty");
      return;
    }
    const collection = await fetchWrapper.post(`${config.apis.api.url}/internalcollection`, {
      injectToken: true,
      body: {
        collection_id: getIdFromTitle(title),
        collection_name: title
      }
    });
    artworks.forEach(async (artwork, index) => {
      await fetchWrapper.post(`${config.apis.api.url}/collection/${collection.data.collection_id}/artwork/${artwork._id}`, {
        injectToken: true,
        body: { index }
      });
    });
    navigate("/admin/customize-home");
  };
  
  function deleteArtwork(artworkToDelete) {
    const newArtworks = artworks.filter(artwork=>artwork._id !== artworkToDelete._id);

    setArtworks(newArtworks);
  }

  function handleSortEnd(sortedArtworks) {
    setArtworks(sortedArtworks);
  }
  
  function handleDragStart(event) {
    const { active } = event;
    setActiveArtworkId(active.id);
  }

  function handleDragEnd(event) {
    const { active, over } = event;

    setActiveArtworkId(null);

    if (active?.id !== over?.id) {
      const oldIndex = artworks.findIndex(artwork => artwork._id === active.id);
      const newIndex = artworks.findIndex(artwork => artwork._id === over.id);

      handleSortEnd(arrayMove(artworks, oldIndex, newIndex));
    }
  }

  return (
    <div className="customize-existing-carousel__container">
      <div className="customize-existing-carousel__header">
        <div className="customize-existing-carousel__header-back">
          <BackArrowIcon onClick={onClickBack} />
        </div>
        <h4 className="customize-existing-carousel__header-text">Home</h4>
        <div className="customize-existing-carousel__header-logout">
          <ContinueButton onClick={onSaveChanges}>Save changes</ContinueButton>
        </div>
      </div>
      <div>
        <PublicFormInput
          className="customize-existing-carousel__title-input"
          error={error}
          placeholder="Title"
          element="title"
          margin
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <ContinueButton onClick={() => setPopupOpen(true)}>
          ADD ARTWORKS
        </ContinueButton>
        <div className="customize-existing-carousel__artworks-container">
          <DndContext
            sensors={sensors} 
            modifiers={[restrictToVerticalAxis, restrictToParentElement]} 
            collisionDetection={closestCenter} 
            onDragStart={handleDragStart} 
            onDragEnd={handleDragEnd}
          >
            <SortableContext items={artworks.map(artwork => artwork._id)} strategy={verticalListSortingStrategy}>
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    width={width}
                    height={height}
                    className="remove-scrollbar"
                    overscanRowCount={3}
                    rowCount={artworks.length}
                    rowHeight={76}
                    rowRenderer={({ key, index, style }) => (
                      <ArtworkRow 
                        key={key} 
                        style={style} 
                        item={artworks[index]} 
                        deleteItem={()=>deleteArtwork(artworks[index])}
                      />
                    )}
                  />
                )}
              </AutoSizer>
            </SortableContext>

            <DragOverlay>
              {
                activeArtworkId ? 
                  <ArtworkRow item={artworks.find(artwork=>artwork._id === activeArtworkId)} isActive/> 
                  :
                  null
              }
            </DragOverlay>
          </DndContext>
        </div>
      </div>
      <AddArtworksPopup open={popupOpen} onClose={() => setPopupOpen(false)} artworks={artworks} addArtworks={onAddArtworks} />
    </div>
  );
}
